export default __webpack_public_path__ + "static/514-f5ed8192981ad9f3241ceea176e487c0.gif";